import request from '@/utils/request';

/**
 * 用户列表
 * @param params 参数
 */
export const getUserList = (params: any) =>
  request({
    url: '/api/v1/omc/user/list',
    method: 'get',
    params,
  });
/* 用户列表-设置用户黑名单 */
export const getUserDisable = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/user/disable',
    method: 'put',
    data,
  });
/* 用户列表-设置为推广员/普通等角色 */
export const getUserRole = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/user/role',
    method: 'put',
    data,
  });
/**
 * 据邀请人获取被邀请人的详情
 * @param params 参数
 */
export const getUserInviteDetailList = (params: any) =>
  request({
    url: '/api/v1/omc/user/invite_detail',
    method: 'get',
    params,
  });
